<section class="thank-you">
  
  <div class="container">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 offset-lg-2 offset-xl-2">
        <div class="banner-item" class="banner-item" >
            <img src="/assets/images/instructor-request.jpeg"  class="img-fluid" alt="banner-image" alt="">
            
          <div class="carousel-caption">
            <div class="container">
              <div class="row">
                <div class="col-12 px-5 text-left">
                  <div class="instructor-header card">
                    <h3 class="heading-3">{{translationScope+'.become_an_instructor' | transloco}}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 offset-lg-2 offset-xl-2">
        <h1 class="h1">{{translationScope+'.thank_you_application' | transloco}}</h1>
        <div class="row">
          <div class="col-12">
            <p class="paragraph">
              {{translationScope+'.instructor_request_success' | transloco}}
            </p>

            <button class="btn btn-primary text-uppercase" (click)="gotoHome()">{{translationScope+'.go_to_homepage' | transloco}}</button>
              
          </div>
        </div>
      </div>
    </div>
  </div>
</section>